import ImageSlider from './ImageSlider'

export default ImageSlider

export { ImageSlider }
